import PageHeader from "@/components/PageHeader";
import { CURRENT_USER, MOCK_REFERRALS, formatTimeFromNow } from "@/lib/mockData";
import { Copy, Share2 } from "lucide-react";
import { toast } from "sonner";

const STATUS_COLOR = {
  rewarded: "#C8E6C9",
  verified: "#FFFBEB",
  signed_up: "#FFCC00",
  clicked: "#F8F9FA",
};

const Referrals = () => {
  const copy = () => {
    navigator.clipboard?.writeText(CURRENT_USER.referral_code);
    toast.success("Code copied");
  };

  return (
    <div data-testid="referrals-page">
      <PageHeader title="Referrals" subtitle="25 tokens per friend who shows up." />

      <div className="brutal-card p-6 bg-[#FF6A2C] text-white">
        <div className="label-mono opacity-80 mb-2">Your code</div>
        <div className="font-mono font-black text-4xl tracking-wider mb-4">{CURRENT_USER.referral_code}</div>
        <div className="flex gap-2">
          <button onClick={copy} className="brutal-btn bg-white text-[#0A0A0A] px-4 py-2.5 text-sm flex items-center gap-2" data-testid="copy-referral-code">
            <Copy className="w-4 h-4" /> Copy
          </button>
          <button className="brutal-btn bg-[#0A0A0A] text-white px-4 py-2.5 text-sm flex items-center gap-2" data-testid="share-referral-code">
            <Share2 className="w-4 h-4" /> Share
          </button>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 mt-4">
        <Stat n={MOCK_REFERRALS.length} label="Sent" />
        <Stat n={MOCK_REFERRALS.filter((r) => r.status !== "clicked").length} label="Signed up" />
        <Stat n={MOCK_REFERRALS.filter((r) => r.status === "rewarded").length} label="Rewarded" />
      </div>

      <h3 className="font-heading font-bold text-xl mt-6 mb-3">Your referrals</h3>
      <div className="brutal-card divide-y-2 divide-[#0A0A0A]">
        {MOCK_REFERRALS.map((r) => (
          <div key={r.id} className="p-4 flex items-center justify-between" data-testid={`referral-${r.id}`}>
            <div>
              <div className="font-bold">{r.referee_name}</div>
              <div className="text-[10px] text-[#555555] font-mono">{formatTimeFromNow(r.iso)}</div>
            </div>
            <span
              className="brutal-border rounded-full px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide"
              style={{ background: STATUS_COLOR[r.status] }}
            >
              {r.status.replace("_", " ")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const Stat = ({ n, label }) => (
  <div className="brutal-card p-3 text-center">
    <div className="font-heading font-black text-2xl">{n}</div>
    <div className="label-mono text-[#555555] mt-1">{label}</div>
  </div>
);

export default Referrals;
